<template>
  <div id="app">
    <!-- <Navigation /> -->
    <main>
      <router-view />
    </main>
  </div>
</template>

<script>
// import Navigation from "./components/Navigation.vue";

export default {
  name: "App",
  // components: {
  //   Navigation,
  // },
  created() {
    // AUTHENTICATION - Temporarily disabled, can be re-enabled later
    // Initialize auth state when app starts
    // this.$store.dispatch("initAuth");
  },
};
</script>
